
export default {
    data() {
        return {
            fullPage: false
        }
    },
    methods: {
        openLoader(tipoLoader = null, lg = null, al = null){
            var tipo = tipoLoader || 'spinner'; //'dots' 'bars'
            var twidth = lg || 64 ;//'dots' 'bars'
            var theight = al || 64; //'dots' 'bars'
            var loader = this.$loading.show({
                // Optional parameters
                loader: tipo,
                container: this.fullPage ? null : this.$refs.formContainer,
                canCancel: true,
                opacity: 0,
                onCancel: this.onCancel,
                color: '#002bdc',
                width: twidth,
                height: theight,
            });

            return loader
        },
    }
}
